import { ReactNode } from "react";

interface CategoryIconProps {
    icon: ReactNode;
    label: string;
    isActive?: boolean;
    onClick?: () => void;
}

export default function CategoryIcon({
    icon,
    label,
    isActive = false,
    onClick,
}: CategoryIconProps) {

    return (
        <button
            onClick={onClick}
            className={`flex flex-col items-center gap-2 px-3 py-2 rounded-lg transition-colors ${isActive
                ? "text-blue-600 dark:text-blue-400"
                : "text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400"
                }`}
        >
            <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${isActive
                    ? "bg-blue-50 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400"
                    : "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 hover:bg-blue-50 hover:text-blue-600 dark:hover:bg-blue-900/30 dark:hover:text-blue-400"
                    }`}
            >
                {icon}
            </div>
            <span className="text-xs font-medium">{label}</span>
        </button>
    );
}
